import axios from 'axios'

export default() => {
    return axios.create({
        baseURL: 'https://simbio.termos.digitise.ru/api',
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
}
